import { createFileRoute } from "@tanstack/react-router";
import BrandCitySeoPage from "@/pages/BrandCitySeoPage";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/masini/$brand/$city/")({
  head: ({ params }) => routeHead("/masini/$brand/$city/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <BrandCitySeoPage />
  );
}
